import type { ReactNode } from 'react'
import { Box, Paper, Typography } from '@mui/material'

/** M mascot + speech bubble (Clippy-style) for guided flows such as OPTins setup. */
export function GuideMascotCallout({
  children,
  centered = false,
}: {
  children: ReactNode
  /** When true, mascot + bubble are centered as a group (e.g. OPTins guide). */
  centered?: boolean
}) {
  return (
    <Box
      sx={{
        mb: 3,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        justifyContent: { xs: 'center', sm: centered ? 'center' : 'flex-start' },
        gap: { xs: 2, sm: 3 },
      }}
    >
      <Box sx={{ display: 'flex', flexShrink: 0, justifyContent: 'center' }}>
        <Box
          component="img"
          src="/misc-clippy-mascot.png"
          alt="MISC mascot"
          width={128}
          height={128}
          decoding="async"
          sx={{
            height: { xs: 112, sm: 128 },
            width: { xs: 112, sm: 128 },
            objectFit: 'contain',
          }}
        />
      </Box>
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          maxWidth: centered ? '48rem' : { sm: '48rem' },
          textAlign: centered ? 'center' : undefined,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            position: 'relative',
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            backgroundColor: '#ffffff',
            px: { xs: 1.5, sm: 2 },
            py: { xs: 1.25, sm: 1.5 },
            boxShadow: 3,
          }}
        >
          <Typography
            component="div"
            sx={{
              fontSize: 14,
              lineHeight: 1.625,
              color: '#1e293b',
              textAlign: centered ? 'center' : 'left',
            }}
          >
            {children}
          </Typography>
          <Box
            component="span"
            aria-hidden
            sx={{
              pointerEvents: 'none',
              position: 'absolute',
              bottom: { xs: 16, sm: '14px' },
              left: -8,
              height: 0,
              width: 0,
              borderTop: '8px solid transparent',
              borderBottom: '8px solid transparent',
              borderRight: '9px solid #ffffff',
              filter: 'drop-shadow(-1px 0 0 rgb(226, 232, 240))',
            }}
          />
        </Paper>
      </Box>
    </Box>
  )
}
